import React, { useState, useEffect } from 'react';
import { axios } from '../../services/ServiceUtils';
import { NavbarBrand } from 'reactstrap';
import { withRouter } from 'react-router-dom';
import LanguageSelector from '../LanguageSelector';
import { useConfigContext } from '../../contexts/ConfigContext';
import { useMediaQuery } from 'react-responsive';
import {
  HeaderPilot,
  Toggler,
  Teardrop,
  ChevronIcon,
  Logo,
  ContainerBox,
  Navbar,
  Nav,
  Dropdown,
  NavLink,
  DropdownToggle,
  DropdownItem,
  DropdownMenu,
  Collapse,
} from './styles';

export default withRouter(({ language, showActions }) => {
  const { TOGGLE, allowedHeaders } = useConfigContext();
  const [data, setData] = useState({ headerItems: [], logo: '', signIn: '' });
  const isTabletSize = useMediaQuery({ minWidth: 992 });
  const showItems = showActions ?? true;
  useEffect(() => {
    axios
      .get('api/header', {
        headers: {
          'Content-Language': `${language.locale}`,
        },
      })
      .then(result => setData(result.data))
      .catch(e => {
        // eslint-disable-next-line
        console.error('request error', e);
      });
  }, [language]);

  const [isOpen, setIsOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState({});
  const { logo, headerItems } = data;
  const toggle = () => setIsOpen(!isOpen);

  return (
    <>
      <HeaderPilot noitems={showActions}>
        <Navbar color="white" light expand="lg" className="py-0 px-lg-2">
          <ContainerBox>
            <NavbarBrand href="/" className="mr-sm-0 flex-fill flex-lg-grow-0 ml-sm-0">
              {logo && (
                <Logo
                  src={`${logo.path}`}
                  alt="Dell Technologies"
                  title="Dell Technologies"
                />
              )}
            </NavbarBrand>
            {allowedHeaders?.includes(language?.locale?.toLowerCase()) && (
              <>
                <Toggler onClick={toggle} type="button" className="navbar-toggler ml-auto">
                  <div className="dds__icons">☰</div>
                  <span>Menu</span>
                </Toggler>
                <Collapse isOpen={isOpen} navbar>
                  <Nav navbar>
                    {headerItems &&
                      showItems &&
                      headerItems.map((item, index) => (
                        <Dropdown
                          onMouseOver={() =>
                            isTabletSize && setIsDropdownOpen(isOpen => ({ ...isOpen, [index]: true }))
                          }
                          onMouseLeave={() =>
                            isTabletSize && setIsDropdownOpen(isOpen => ({ ...isOpen, [index]: false }))
                          }
                          toggle={() =>
                            setIsDropdownOpen(isOpen => ({ ...isOpen, [index]: !isOpen[index] }))
                          }
                          a11y={false}
                          isOpen={isDropdownOpen[index]}
                          key={item.label}
                          nav
                        >
                          <DropdownToggle tag="button" type="button" caret nav>
                            {item.label}
                            <ChevronIcon className="dds__icons dds__chevron-down"></ChevronIcon>
                          </DropdownToggle>
                          <DropdownMenu>
                            {item.headerLinks.map(subitem => {
                              const target = subitem.parameters
                                ? subitem.parameters
                                  .split('target="')
                                  .pop()
                                  .split('"')[0]
                                : '_self';
                              return (
                                <DropdownItem
                                  key={subitem.title}
                                  href={subitem.url}
                                  tag={NavLink}
                                  target={target}
                                >
                                  {subitem.title}
                                </DropdownItem>
                              );
                            })}
                          </DropdownMenu>
                        </Dropdown>
                      ))}
                  </Nav>
                </Collapse>
              </>
            )}
            <Teardrop onClick={toggle} className={isOpen ? 'show' : ''} />
            {TOGGLE.toggleLanguageSelector && (
              <Nav className="ml-auto" navbar>
                <LanguageSelector />
              </Nav>
            )}
          </ContainerBox>
        </Navbar>
      </HeaderPilot>
    </>
  );
});
